import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

export interface IDynamicForm {
  form: FormGroup<any>;
}

interface IApiErrors {
  [key: string]: string[] | IApiErrors;
}

@Injectable({
  providedIn: 'root',
})
export class DynamicFormsService {
  activeForms: IDynamicForm[] = [];

  addForm(form: IDynamicForm) {
    this.activeForms.push(form);
  }

  removeForm(form: IDynamicForm) {
    this.activeForms = this.activeForms.filter((f) => f !== form);
  }

  setApiErrors(errors: IApiErrors) {
    this.activeForms.forEach(({ form }) => {
      // Recursively set errors on the form controls
      const setErrors = (
        ctrl: FormGroup<any> | FormArray<any>,
        errs: IApiErrors,
      ) => {
        Object.keys(errs).forEach((key) => {
          const control = ctrl.get(key);

          if (control) {
            if (Array.isArray(errs[key]) && errs[key].length > 0) {
              const messages = errs[key];
              const message =
                messages[0] +
                (messages.length > 1 ? ` (+${messages.length - 1})` : '');

              control.setErrors({
                serverError: { message },
              });
            } else {
              // Nested errors, recurse
              if (
                (control instanceof FormGroup ||
                  control instanceof FormArray) &&
                typeof errs[key] === 'object'
              ) {
                setErrors(control, errs[key] as IApiErrors);
              }
            }
          }
        });
      };

      setErrors(form, errors);
    });
  }
}
